import { IonCol, IonGrid, IonRow, isPlatform } from "@ionic/react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import React, {
  ChangeEvent,
  forwardRef,
  ReactNode,
  SetStateAction,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { GenerateGUID } from "../Common";

import api from "./../../services/api";

// import { v4 as uuidv4, v4 } from "uuid";

export type DriverDataResponse = {
  street: string;
  city: string;
  houseNumber: string;
  comment: string;
  commentExtra: string;
  image: string;
  region: string;
  postCode: string;
  phone: string;
  imageProcessed: boolean;
}

type Props = {
  setDriver: React.Dispatch<React.SetStateAction<string>>;
  setRouteId: React.Dispatch<React.SetStateAction<number | undefined>>;
  width?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  date?: string;
  driver?: string;
};

type Option = {
  id: number;
  value: string;
}

const RouteAddressesAutocomplete: React.FC<Props> = ({
  setDriver,
  setRouteId,
  width,
  date,
  driver,
  disabled = false,
  fullWidth = false,
}) => {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState<readonly Option[]>([]);
  const loading = open && options.length === 0;

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    api.get("autocomplete/route-addresses-by-date", {
      params: {
        date: date,
        driver: driver
      }
    }).then((response) => {
      setOptions(response.data);
    });

    return () => {
      active = false;
    };
  }, [loading]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  return (
    <Autocomplete
      disabled={disabled}
      noOptionsText="Nie znaleziono"
      // id={v4()}
      sx={{
        width: {
          xs: "100%",
          sm: "100%",
          md: "100%"
        },
      }}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      isOptionEqualToValue={(option, value) => option === value}
      getOptionLabel={(option) => {
        return option.value;
      }}
      onChange={(event, value) => {
        setDriver(value?.value ?? "");
        setRouteId(value?.id);
      }}
      options={options}
      loading={loading}
      renderInput={(params) => (
        <TextField
          variant="filled"
          type={"search"}
          className="shadow-mui"
          {...params}
          id={GenerateGUID()}
          autoComplete={GenerateGUID()}
          label="Adres na trasie"
          fullWidth={true}
          InputProps={{
            ...params.InputProps,
            autoComplete: "off",
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
};

export default RouteAddressesAutocomplete;
